import _ from "lodash";

export default position => _.flatten(position.map(p => ["children", p - 1]));
